import Activity from "@/views/activity/activity.vue";
import FormActivity from "@/views/activity/FormActivity.vue";
import PreviewActivity from "@/views/activity/PreviewActivity";

export default [
    {
        path: "/activity",
        name: "Activity",
        component: Activity
    },
    {
        path: "/new-activity/:id",
        name: "NewActivity",
        component: FormActivity
    },
    {
        path: "/update-activity/:id",
        name: "UpdateActivity",
        component: FormActivity
    },
    {
        path: "/preview-activity/:id",
        name: "PreviewActivity",
        component: PreviewActivity
    },

    {
        path: "/activity/:id/:type",
        name: "ActivityType",
        props: true,
        component: () =>
            import(
                /* webpackChunkName: "TypeActivity" */ "@/views/activity/TypeActivity.vue"
            ),
        meta: {
            requiresAuth: true
        }
    }
];
